import React, { useEffect, useState, FC } from "react";
import { GetInventoryProduct } from "../../api/product";
import { Spin, Alert } from "antd";
import { Table } from "antd";
import { datahelper, columns } from "../../helpers/history.helper";
import { useGlobalState } from "../../context/Provider";
import "./productInventory.style.scss";

type FormSkuProps = {
  info: any;
};
const ProudctInventory: FC<FormSkuProps> = (props) => {
  const { info }: any = props;
  const { id, warehouseId }: any = info;
  const { langState, warehouserList }: any = useGlobalState();
  const lang = langState.locale;

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  useEffect(() => {
    const params = {
      maxResultCount: 5,
      skipCount: 0,
      productId: id,
      warehouseId: warehouseId,
      creatorEmail: "",
    };

    GetInventoryProduct(params).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setData(datahelper(res.data.items, 1));
      }
    });
  }, []);
  return (
    <>
      {loading ? (
        <Spin tip="Loading...">
          <Alert message="Loading ...." type="info" />
        </Spin>
      ) : (
        <Table
          className="tableProductInventroy"
          columns={columns(lang, warehouserList.data)}
          dataSource={data}
          size="middle"
          pagination={false}
          scroll={{ y: "calc(100vh - 280px)" }}
          loading={loading}
        />
      )}
    </>
  );
};

export default ProudctInventory;
